import 'slick-carousel';
import Wow from 'wow.js';

export default {
	init() {
		// JavaScript to be fired on all pages
		const wow = new Wow();
		wow.init();

		// Initialise mobile menu

		// Get all "navbar-burger" elements
		var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

		// Check if there are any navbar burgers
		if ($navbarBurgers.length > 0) {

			// Add a click event on each of them
			$navbarBurgers.forEach(function ($el) {
				$el.addEventListener('click', function () {

					console.log('nav toggle');

					// Get the target from the "data-target" attribute
					var target = $el.dataset.target;
					var $target = document.getElementById(target);

					// Toggle the class on both the "navbar-burger" and the "navbar-menu"
					$el.classList.toggle('is-active');
					$target.classList.toggle('is-active');

				});
			});
		}
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		// Initialise carousels
		

		if ($.fn.slick) {

			$('.testimonials-carousel').each(function(){


				console.log('carousel found');

				var $carousel = $(this);

				if (!$carousel.hasClass('slick-initialized')) {
					$carousel.slick({
						slidesToShow: 1,
					});
				}
          });
		}
	},
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js